var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { padding: "0px !important", margin: "0px" },
      attrs: { wrap: "" }
    },
    [
      _c(
        "v-layout",
        {
          staticStyle: { "background-color": "none !important" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            {
              staticClass: "setBgHeaderRegis widthfull",
              style: { background: _vm.backgroundText },
              attrs: { xs12: "" }
            },
            [
              _c(
                "v-layout",
                {
                  staticStyle: { height: "30px" },
                  attrs: {
                    "align-center": "",
                    "justify-center": "",
                    row: "",
                    wrap: ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "align-center": "",
                            "justify-center": "",
                            row: "",
                            wrap: ""
                          }
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "centerDiv mt-1",
                              staticStyle: { color: "white" }
                            },
                            [_vm._v("แชทกับเจ้าหน้าที่ OSS")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "setHeightChatBoxRegis",
              staticStyle: { height: "100vh" },
              attrs: { xs12: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "white !important",
                    height: "100vh"
                  }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-right": "10px",
                        "padding-bottom": "10px"
                      },
                      attrs: {
                        column: "",
                        wrap: "",
                        "align-center": "",
                        "justify-start": ""
                      }
                    },
                    [
                      _vm.typelogin == ""
                        ? _c(
                            "v-form",
                            {
                              ref: "form",
                              staticStyle: { width: "100% !important" },
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c(
                                "h4",
                                {
                                  staticStyle: { margin: "20px 0px !important" }
                                },
                                [_vm._v("ข้อมูลส่วนตัว")]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                style:
                                  "width: 100% !important; color: " +
                                  _vm.backgroundText +
                                  " !important;",
                                attrs: {
                                  label: "ชื่อ",
                                  rules: _vm.nameRules,
                                  "single-line": "",
                                  solo: ""
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.setlogin("otp")
                                  }
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                style:
                                  "width: 100% !important; color: " +
                                  _vm.backgroundText +
                                  " !important;",
                                attrs: {
                                  label: "นามสกุล",
                                  rules: _vm.lastnameRules,
                                  required: "",
                                  "single-line": "",
                                  solo: ""
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.setlogin("otp")
                                  }
                                },
                                model: {
                                  value: _vm.lastname,
                                  callback: function($$v) {
                                    _vm.lastname = $$v
                                  },
                                  expression: "lastname"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                style:
                                  "width: 100% !important; color: " +
                                  _vm.backgroundText +
                                  " !important;",
                                attrs: {
                                  label: "หมายเลขโทรศัพท์",
                                  mask: "###-###-####",
                                  pattern: "\\d*",
                                  rules: _vm.phoneRules,
                                  required: "",
                                  "single-line": "",
                                  solo: ""
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.setlogin("otp")
                                  }
                                },
                                model: {
                                  value: _vm.phone,
                                  callback: function($$v) {
                                    _vm.phone = $$v
                                  },
                                  expression: "phone"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "align-center": "",
                                    "justify-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      style:
                                        "background-color: " +
                                        _vm.backgroundText +
                                        " !important; width: 100%; border-radius: 7px;",
                                      attrs: {
                                        dark: "",
                                        loading: _vm.loading,
                                        disabled: !_vm.valid
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setlogin("otp")
                                        }
                                      }
                                    },
                                    [_vm._v("เริ่มการแชท")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.typelogin == "otp"
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                padding: "16px 0px"
                              }
                            },
                            [
                              _c("h4", [_vm._v("ยืนยันรหัส OTP")]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "20px",
                                    "margin-bottom": "20px"
                                  }
                                },
                                [_vm._v("เบอร์โทร: " + _vm._s(_vm.phone))]
                              ),
                              _vm._v(" "),
                              _vm.refcode
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "margin-top": "20px",
                                        "margin-bottom": "20px",
                                        color: "#8c8c8c"
                                      }
                                    },
                                    [_vm._v("Refcode: " + _vm._s(_vm.refcode))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticStyle: {
                                    overflow: "hidden !important",
                                    width: "100%"
                                  },
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs8: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticStyle: {
                                          width: "100% !important",
                                          "margin-top": "10px",
                                          "margin-bottom": "10px"
                                        },
                                        attrs: {
                                          label: "OTP",
                                          pattern: "\\d*",
                                          required: "",
                                          "single-line": "",
                                          "hide-details": "",
                                          maxlength: "6"
                                        },
                                        model: {
                                          value: _vm.OTP,
                                          callback: function($$v) {
                                            _vm.OTP = $$v
                                          },
                                          expression: "OTP"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn_otp",
                                          staticStyle: {
                                            "margin-top": "10px !important"
                                          },
                                          attrs: {
                                            depressed: "",
                                            disabled: _vm.counting
                                          },
                                          on: { click: _vm.startCountdown }
                                        },
                                        [
                                          _vm.counting
                                            ? _c("countdown", {
                                                attrs: { time: 60000 },
                                                on: {
                                                  end: _vm.handleCountdownEnd
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(props) {
                                                        return [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.totalSeconds
                                                            ) + " วินาที "
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2818661129
                                                )
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.counting
                                            ? _c("span", [_vm._v("ส่ง OTP ")])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.count_wrongOTP >= 5
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "* คุณใส่ OTP ผิดมากกว่า 5 ครั้ง กรุณารอ "
                                          ),
                                          _c("span", { attrs: { id: "time" } }),
                                          _vm._v(" นาทีเพื่อใส่ OTP ที่ถูกต้อง")
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "5px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn_back",
                                      attrs: {
                                        depressed: "",
                                        disabled: _vm.count_wrongOTP >= 5
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.setlogin("")
                                          _vm.type_otp = ""
                                        }
                                      }
                                    },
                                    [_vm._v("ย้อนกลับ")]
                                  ),
                                  _vm._v(" "),
                                  !_vm.progress && _vm.type_otp == "register"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn_login",
                                          attrs: {
                                            depressed: "",
                                            disabled:
                                              _vm.OTP == "" ||
                                              _vm.count_wrongOTP >= 5
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.login()
                                            }
                                          }
                                        },
                                        [_vm._v("ยืนยัน")]
                                      )
                                    : !_vm.progress &&
                                      _vm.type_otp != "register"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn_login",
                                          attrs: {
                                            depressed: "",
                                            disabled:
                                              _vm.OTP == "" ||
                                              _vm.count_wrongOTP >= 5
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.login()
                                            }
                                          }
                                        },
                                        [_vm._v("ยืนยัน")]
                                      )
                                    : _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn_login",
                                          attrs: { depressed: "", disabled: "" }
                                        },
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              size: 10,
                                              width: 2,
                                              indeterminate: "",
                                              color: "blue"
                                            }
                                          }),
                                          _vm._v("  ถัดไป\n    ")
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf3755a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf3755a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = null
// module chunks = 